import script from "./RemoveCaseManagerModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./RemoveCaseManagerModal.vue?vue&type=script&setup=true&lang=ts"

import "./RemoveCaseManagerModal.vue?vue&type=style&index=0&id=0c97587c&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0c97587c"]])

export default __exports__